export type TStaffMember = {
  staffId: string;
  name?: string;
  email?: string;
  lastName?: string;
  initials?: string;
  firstName?: string;
  fillColor?: string;
  strokeColor?: string;
  isFormerStaff?: boolean;
};

// eslint-disable-next-line -- unless we want to generate types from the schema
export const mapStaffMemberFromGQL = (raw: any): TStaffMember | null => {
  if (!raw) {
    return null;
  }

  const { id, firstName, lastName, initials, isFormerStaff, email, colorFill, colorStroke } = raw;

  if (!id) {
    return null;
  }

  return {
    firstName,
    lastName,
    initials,
    isFormerStaff,
    email,
    staffId: id,
    fillColor: colorFill,
    strokeColor: colorStroke,
    name: `${firstName} ${lastName}`.trim(),
  };
};
